import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { NumberCoordinate, LotteryParam, LotteryParamOption } from '../../lottoloca-commom/lottery-modex';
import { FocusMonitor } from '@angular/cdk/a11y';
import { List } from 'linqts';
import { EventEmitter } from 'events';

@Component({
  selector: 'lottery-param',
  templateUrl: './lottery-param.component.html',
  styleUrls: ['./lottery-param.component.css'],
  providers: [
    
    { provide: MatFormFieldControl, useExisting: LotteryParamComponent },
 
  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
 })
export class LotteryParamComponent implements MatFormFieldControl<LotteryParam>, ControlValueAccessor, OnInit {

  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'lottery-param';
  id = `lottery-param-${LotteryParamComponent.nextId++}`;
  describedBy = '';
  _isReady: boolean = false;

  private onChange: (value: any,event:EventEmitter) => void;
  _value: LotteryParam;


  constructor(@Optional() @Self() public ngControl: NgControl,
    fb: UntypedFormBuilder,
    private fm: FocusMonitor,
    private elRef: ElementRef<HTMLElement>,
    private formBuilder: UntypedFormBuilder) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.parts = fb.group({
      textValue: ''
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }


  writeValue(obj: LotteryParam): void {

    this.value = obj;
  }
  registerOnChange(onChange: (value: any,event:EventEmitter) => void): void {


    this.onChange = onChange;
  }



  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.parts.get("textValue").disable();
    }
    else {
      this.parts.get("textValue").enable();
    }
  }


  get empty() {
    const { value: { textValue } } = this.parts;

    // console.log("empty:" + dateText + !dateText);
    return !textValue;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): LotteryParam | null {


    return this._value;

  }

  set value(value: LotteryParam | null) {

    // if (value == null) {
    //   this._value = [];
    // }
    // else {

      this._value = value;
   // }

    this.updateGui();

    this.stateChanges.next();
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      this.elRef.nativeElement.querySelector('input')!.focus();
    }
  }



  //******************************* */

  public _indexes: any[] = [];

  public updateGui(): any {



    this.orderForm = this.formBuilder.group({
      description: this.value.description,
      options: this.formBuilder.array( this.value.options)
    });


    this.orderForm
      .valueChanges
      .subscribe(() => {
        this.propagateChanges();
      }
      );

  }

  public showValue() {
  
  }

  public onChangeCoordinate(X: number, Y: number, value: any) {


  }

  public addParameter() {


    this.addItem();


  }

  addItem(): void {

    this.items = this.orderForm.get('items') as UntypedFormArray;

    this.items.push(this.createItem(this.orderForm.get('newDescription').value, []));

  }

  public propagateChanges() {
    this._value = this.orderForm.value.items;

    if (this.onChange != null) {
      this.onChange(  this.value, null)
    }
  }

  public showValues() {

  }


  createItem(description: string, options: LotteryParamOption[]): UntypedFormGroup {

    return this.formBuilder.group({
      description: description,
      options:  this.formBuilder.array( options)
    });


  }

  orderForm: UntypedFormGroup;
  items: UntypedFormArray;


  ngOnInit() {
    this.updateGui();
  }
}
